<template>
  <div class="container-fluid background--light">
    <div class="container" v-if="token">
      <div class="section section--small">
        <div class="h2 h2--primary">Potwierdzenie zamówienia</div>
      </div>
      <div class="section--margins section--small">
        <div v-if="loading">Trwa wczytywanie...</div>
        <div class="order-completed" v-else>
          <div class="order-completed__head">
            <router-link :to="{ name: 'Home', params: { lang: 'pl' } }">
              <svg xmlns="http://www.w3.org/2000/svg" width="155.12" height="30.731" viewBox="0 0 155.12 30.731" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="a" fill="#a5a4a4" d="M151.757 10.9a11.933 11.933 0 11-1.89-3.527l2.338-1.465a14.657 14.657 0 101.953 3.551l-2.4 1.441z"/><path class="b" fill="#e95e0c" d="M133.153 23.361h6.582v-2.268h-3.457l2.961-6.756a5.228 5.228 0 00.5-2.283V9.928c0-2.945-.559-3.338-3.323-3.338-3.023 0-3.3.535-3.3 3.338v2.5h2.837V9.527c0-.48.1-.717.417-.717.378 0 .457.236.457.717v2.362a3.562 3.562 0 01-.4 1.772l-3.283 7.433v2.268zm11.07-13.741v6.716h-1.07l.874-6.716zm2.724 8.929h.772v-2.2h-.772V6.661h-4.212l-2.165 9.685v2.2h3.575v4.811h2.8V18.55z"/><path class="c" fill="#666665" d="M65.241 14.377a6.075 6.075 0 11-12.141 0 6.074 6.074 0 1112.141 0zm2.992.118a8.811 8.811 0 00-8.697-9.062A7.9 7.9 0 0053.1 8.754V5.803l-2.874.409v24.519l2.874-.409V20.196a7.14 7.14 0 006.275 3.158 8.875 8.875 0 008.861-8.859zm10.661-5.819h.7V5.637a5.292 5.292 0 00-4.638 2.787V5.803l-2.866.409v17.055l2.866-.409v-8.977c0-3.488 1.472-5.2 3.937-5.2zm15.086.654l-9.677 6.11a6.165 6.165 0 015.866-7.586 4.924 4.924 0 013.811 1.472zm-8.858 8.2l12.59-7.834C95.665 6.783 93.2 5.35 90.287 5.35a8.674 8.674 0 00-8.732 8.984 8.811 8.811 0 008.567 9.063 9.347 9.347 0 006.149-2.213l-.74-2.622a8.023 8.023 0 01-5.37 2.008 5.7 5.7 0 01-5.039-3.039zm24.936.575c0-2.457-1.228-3.693-3.693-4.63-2.134-.74-3.9-1.394-3.9-3.323a2.5 2.5 0 012.622-2.417 3.95 3.95 0 013.118 1.8l1.6-1.764a5.863 5.863 0 00-4.834-2.3 5.113 5.113 0 00-5.37 5.252c0 2.583 1.52 3.811 4.307 4.756 2.008.7 3.2 1.268 3.2 2.913a2.583 2.583 0 01-2.874 2.583 4.219 4.219 0 01-3.488-1.724l-1.433 2.134a6.468 6.468 0 004.921 1.968c3.4-.008 5.827-2.181 5.827-5.252zm13.362 0c0-2.457-1.228-3.693-3.693-4.63-2.134-.74-3.9-1.394-3.9-3.323a2.5 2.5 0 012.622-2.417 3.95 3.95 0 013.118 1.8l1.6-1.764a5.863 5.863 0 00-4.834-2.3 5.113 5.113 0 00-5.37 5.252c0 2.583 1.52 3.811 4.307 4.756 2.008.7 3.2 1.268 3.2 2.913a2.583 2.583 0 01-2.874 2.583 4.219 4.219 0 01-3.488-1.724l-1.433 2.134a6.468 6.468 0 004.921 1.968c3.409-.008 5.827-2.181 5.827-5.252z"/><path class="b" fill="#e95e0c" d="M15.007 14.377a6.135 6.135 0 01-6.071 6.315 6.165 6.165 0 01-6.071-6.315 6.13 6.13 0 016.072-6.275 6.125 6.125 0 016.071 6.275zm2.993.118a8.811 8.811 0 00-8.693-9.062 7.908 7.908 0 00-6.441 3.321V5.803L0 6.212v24.519l2.874-.409V20.196a7.14 7.14 0 006.275 3.158A8.869 8.869 0 0018 14.495zm10.66-5.818h.7v-3.04a5.292 5.292 0 00-4.638 2.787V5.803l-2.874.409v17.055l2.874-.409v-8.977c0-3.488 1.48-5.2 3.937-5.2zm15.094.654l-9.677 6.11a6.165 6.165 0 015.866-7.587 4.935 4.935 0 013.811 1.472zm-8.858 8.2l12.59-7.834c-2.047-2.91-4.511-4.343-7.425-4.343a8.674 8.674 0 00-8.732 8.984A8.812 8.812 0 0039.9 23.4a9.347 9.347 0 006.149-2.213l-.74-2.622a8.023 8.023 0 01-5.37 2.008 5.689 5.689 0 01-5.039-3.038z"/></svg>
            </router-link>
            <div class="order-completed__address">
              <div>ul. Powsińska 69/71 Bud. L</div>
              <div>02-903 Warszawa</div>
              <a href="tel:+48223531800">+48 22 353 18 00</a>
              <a href="mailto:biuro@prepress24.pl">biuro@prepress24.pl</a>
            </div>
          </div>
          <div class="order-completed__body">
            <div class="order-completed__main-info">
              <div class="order-completed__body-left">
                <div class="table-row">
                  <strong class="table-cell">Zamówienie z dnia:</strong>
                  <div class="table-cell">
                    {{
                      new Date(orderInfo.checkoutCompletedAt)
                        | date("dd-MM-yyyy")
                    }}
                  </div>
                </div>
                <div class="table-row">
                  <strong class="table-cell">Forma płatności:</strong>
                  <div class="table-cell">{{ paymentWay }}</div>
                </div>
              </div>
              <div class="order-completed__body-right">
                <div class="order-completed__shippment-way table-row">
                  <strong class="table-cell">Kurier:</strong>
                  <div class="table-cell">{{ shipmentWay }}</div>
                </div>
                <div class="order-completed__shippment-address table-row">
                  <strong class="table-cell">Adres dostawy:</strong>
                  <div class="table-cell">
                    {{ shippingAddress.firstName }} {{ shippingAddress.lastName
                    }}<br />
                    {{ shippingAddress.street }}<br />
                    {{ shippingAddress.postcode }}<br />
                    {{ shippingAddress.city }}
                  </div>
                </div>
              </div>
            </div>

            <div class="order-completed__products">
              <div class="div-table">
                <div class="div-table-heading">
                  <div class="div-table-row">
                    <div class="div-table-cell">Numer zamówienia</div>
                    <div class="div-table-cell">Nazwa produktu</div>
                    <div class="div-table-cell">Nazwa pracy</div>
                    <div class="div-table-cell div-table-cell--center">
                      Ilość
                    </div>
                    <div class="div-table-cell div-table-cell--right">Cena</div>
                  </div>
                </div>
                <div class="div-table-body">
                  <div
                    class="div-table-row"
                    v-for="(item, index) in orderInfo.items"
                    :key="index"
                  >
                    <div class="div-table-cell">
                      <strong class="visible-lg-down"
                        >Numer zamówienia:</strong
                      >
                      {{ orderInfo.number }}
                    </div>
                    <div class="div-table-cell">
                      <strong class="visible-lg-down">Nazwa produktu:</strong>
                      {{ item.product.name }}
                    </div>
                    <div class="div-table-cell">
                      <strong class="visible-lg-down">Nazwa pracy:</strong>
                      {{
                        getValueFromFieldLabel(
                          item.configuration,
                          "Nazwa pracy"
                        )
                      }}
                    </div>
                    <div class="div-table-cell div-table-cell--center">
                      <strong class="visible-lg-down">Ilość:</strong>
                      {{ item.quantity }}
                    </div>
                    <div class="div-table-cell div-table-cell--right">
                      <strong class="visible-lg-down">Cena:</strong>
                      {{ formatCash(item.total) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="div-table div-table--resume">
                <div class="div-table-row">
                  <div class="div-table-cell">
                    <strong>Netto:</strong>
                  </div>
                  <div class="div-table-cell">
                    {{ formatCash(orderInfo.totals.items) }}
                  </div>
                </div>
                <div class="div-table-row">
                  <div class="div-table-cell">
                    <strong>Wysyłka:</strong>
                  </div>
                  <div class="div-table-cell">
                    {{ formatCash(orderInfo.totals.shipping) }}
                  </div>
                </div>
                <div class="div-table-row">
                  <div class="div-table-cell">
                    <strong>VAT:</strong>
                  </div>
                  <div class="div-table-cell">
                    {{ formatCash(orderInfo.totals.taxes) }}
                  </div>
                </div>
                <div class="div-table-row">
                  <div class="div-table-cell">
                    <strong>Razem:</strong>
                  </div>
                  <div class="div-table-cell">
                    {{ formatCash(orderInfo.totals.total) }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="paymentButton">
              <ButtonPrimary v-on:click="redirectToPayment()" class="button--big">Zapłać</ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/pages/order-completed";
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { actionTypes } from "@/store/modules/Order/action-types";
import { getterTypes } from "@/store/modules/Order/getter-types";
import { dateFilter } from "vue-date-fns";
import { helperMixin } from "@/mixins/helpers.js";

export default {
  name: "OrderCompleted",
  metaInfo: {
    titleTemplate: "%s - Potwierdzenie zamówienia",
  },
  props: {
    token: {
      type: String,
    }
  },
  mixins: [helperMixin],
  filters: {
    date: dateFilter,
  },
  components: {
    'ButtonPrimary': () => import('@/pages/components/buttons/ButtonPrimary'),
  },
  computed: {
    checkoutCompleted() {
      return this.GET_COMPLETE_CHECKOUT();
    },
    orderInfo() {
      return this.GET_ORDER_INFO();
    },
    paymentWay() {
      if (!this.orderInfo.payments || !this.orderInfo.payments[0]) {
        return "Brak";
      }
      return this.orderInfo.payments[0].method.name;
    },
    paymentButton() {
      if (!this.orderInfo.payments || !this.orderInfo.payments[0]) {
        return false;
      }
      if (this.orderInfo.paymentState === 'cancelled' || this.orderInfo.paymentState === 'paid') {
        return false;
      }
      return this.orderInfo.payments[0].method !== 'FREE_PAYMENT_METHOD';
    },
    shipmentWay() {
      if (!this.orderInfo.shipments || !this.orderInfo.shipments[0]) {
        return "Brak";
      }
      return this.orderInfo.shipments[0].method.name;
    },
    shippingAddress() {
      if (!this.orderInfo) {
        return false;
      }

      return this.orderInfo.shippingAddress;
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    if (this.token) {
      await this.ADD_ORDER_INFO(this.token);
      this.loading = false;
    }
  },
  methods: {
    ...mapGetters("OrderModule", [
      getterTypes.GET_COMPLETE_CHECKOUT,
      getterTypes.GET_ORDER_INFO,
    ]),
    ...mapActions("OrderModule", [actionTypes.ADD_ORDER_INFO, actionTypes.PAY_FOR_ORDER]),
    getValueFromFieldLabel(configuration, fieldLabel) {
      if (configuration.values) {
        for (const value in configuration.values) {
          const element = configuration.values[value];
          if (element.label && element.label === fieldLabel && element.value) {
            return element.value;
          }
        }
      }

      return "";
    },
    async redirectToPayment() {
      await this.PAY_FOR_ORDER(this.token)
        .then((response) => {
          window.location.href = response.url;
        });
    }
  },
};
</script>
